import PropTypes from "prop-types";
import React, { useState } from "react";

import Logo from "../Logo";
import { Link, NavLink } from "../TrackedLink";

import hamburger from "./images/hamburger.svg";
import * as styles from "./styles.module.scss";

const Header = ({ sections }) => {
  const [isExpandedNavVisible, setIsExpandedNavVisible] = useState(false);

  const toggleNavVisibility = () =>
    setIsExpandedNavVisible(!isExpandedNavVisible);

  return (
    <div className={styles.wrapper}>
      <header className={styles.container}>
        <div className={styles.logoContainer}>
          <Link to="/">
            <Logo />
          </Link>
        </div>
        <div className={styles.hamburger}>
          <a onClick={toggleNavVisibility}>
            <img src={hamburger} />
          </a>
        </div>
        <nav className={isExpandedNavVisible ? styles.expanded : ""}>
          <ul>
            {sections.map(({ label, to }) => (
              <li key={label}>
                <NavLink
                  className={({ isActive }) => (isActive ? styles.active : "")}
                  to={to}
                  end
                  onClick={() => setIsExpandedNavVisible(false)}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          <ul className={styles.venue}>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? styles.active : "")}
                to="/bexley"
                onClick={() => setIsExpandedNavVisible(false)}
              >
                Bexley
              </NavLink>
            </li>
            <li>
              <NavLink
                className={({ isActive }) => (isActive ? styles.active : "")}
                to="/eltham"
                onClick={() => setIsExpandedNavVisible(false)}
              >
                Eltham
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
    </div>
  );
};

Header.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Header;
